module.exports = {
      id: "action-usage",
      viewBox: "0 0 22.626 18.6",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#action",
      toString: function () {
        return this.url;
      }
    }